// extracted by mini-css-extract-plugin
module.exports = {"instruction":"style_instruction__E9Ihd"};